exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".display-none {\n    display: none;\n}\n.scroll-fixed {\n    position: fixed;\n    top: 55px;\n    z-index: 999;\n    width: 100%;\n    box-shadow: rgba(0, 0, 0, 0.3) 0px 2px 5px;\n    display: block;\n    text-align: center;\n    transition: all 500ms linear 500ms;\n}\n", ""]);

// exports
